export default __webpack_public_path__ + "static/media/thermometer.baa0b2fd.svg";